import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'
import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify)

let theme = {
  themes: {
    light: {
      primary: '#4DB6E7'
    },
    dark: {
      primary: '#4DB6E7'
    }
  }
}

if (window.location.hostname === 'predixon.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#BA9765'
      },
      dark: {
        primary: '#BA9765'
      }
    }
  }
} else if (window.location.hostname === 'outflink.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#FCC100'
      },
      dark: {
        primary: '#FCC100'
      }
    }
  }
} else if (window.location.hostname === 'deloitte.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#86BC25'
      },
      dark: {
        primary: '#86BC25'
      }
    }
  }
} else if (window.location.hostname === 'nisum.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#08C2FF'
      },
      dark: {
        primary: '#08C2FF'
      }
    }
  }
} else if (window.location.hostname === 'mckinsey.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#2251ff'
      },
      dark: {
        primary: '#2251ff'
      }
    }
  }
} else if (window.location.hostname === 'comscore.noisegrasp.com') {
  theme = {
    themes: {
      light: {
        primary: '#E53A2B'
      },
      dark: {
        primary: '#E53A2B'
      }
    }
  }
}

export default new Vuetify({
  theme: {
    ...theme,
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { en, es, pt },
    current: 'en'
  }
})
